import React from 'react'
import BaseComponent, { errorMap } from './BaseComponent'
import Modal from './Modal'
import _ from 'lodash'
import ReactPaginate from 'react-paginate';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import { registerLocale } from "react-datepicker";
import pl from 'date-fns/locale/pl';

registerLocale('pl', pl)

export default class ListPage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { list: [], itemId: null, preloader: true, emailAddress: "", sfId: "", page: 0, pages: 0, category: "test", sortBy: "publicationDate", filters: {}, mapUUID: "", dateBefore: new Date(), dateAfter: new Date(), email: "", phone: "", type: "sfId", ident:"", limit: 20, offset: 0,  touchpoints: ["if u see this", "something is wrong"] }
    this._bind('delete', 'getData', 'emailAddressUpdated', 'closeConfirm', 'handlePageClick')

    this.handleSearch = _.debounce( () => {
      this.setState({ list: [], preloader: true })
      this.getData(this.state.mapUUID)
    }, 600);
  }

  getData(mapUUID) {
    let url = this.props.API+this.props.data.endpointList
    let params = {
      consumer: {emailAddress: this.state.emailAddress, 
        sfId: this.state.sfId,
      },
      touchpoint: "discoverglode",
      session: {
        "token": "dummy", // To jest token magento, nie ma znaczenia dopóki się z nim nie integrujemy
        expires: this.state.total ? null : this.state.dateBefore.getFullYear() + "-" + (this.state.dateBefore.getMonth() + 1).toString().padStart(2, '0') + "-" + this.state.dateBefore.getDate()  + " 23:59:59" // Do kiedy jest ważny token, musi być podane
      },
      // activation: this.state.ident,

    }

    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error)}}), true);
      } else {
        //console.log(result)
        let res = result.data || []
        if (res === null) {
          res = []
        }
        const ordered = res
        this.setState({ pages: Math.ceil(result.data?.total?.length/20) })
        this.setState({ list: ordered, preloader: false, pages: result.data ? result.data.pages : [] })
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie wyzerowano."}}), true);
      }
    }, (error) => {
      console.log(error)
    })
  }

  getListOfTouchpoints() {
    let url = this.props.API+"/dev/touchpoints"
    let params = {
      offset: 0,
      limit: 20
    }

    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident)}}), true);
      } else {
        this.setState({ touchpoints: result.data || [] });
        console.log("✌🏼", result.data)
      }
    }, (error) => {
      console.log(error)
    })
  }

  componentDidMount() {
    if(this.props.data.table === "address") {
      this.getListOfTouchpoints()
    } else {
      // this.getData()
    }
    this.getListOfTouchpoints()
  }

  delete(id) {
    this.setState({ preloader: true })
    let url = this.props.API+this.props.data.endpointDelete
    const params = {
      [this.props.data.table]: {
        uuid: id
      }
    }
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
      },
      body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      this.setState({ confirm: false, itemId: null })
      this.getData()
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error)}}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie wyzerowano."}}), true);
      }
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Something went wrong."}}), true);
      this.setState({ preloader: false })
    })
  }

  emailAddressUpdated(name) {
    this.setState({emailAddress: name})
  }

  closeConfirm() {
    this.setState({ confirm: false, itemId: null })
  }

  handlePageClick(data) {
    this.setState({ page: data.selected, preloader: true }, () => {
      this.getData(this.state.mapUUID)
    })
  }

  render () {
    let list = null
    let filteredList = this.state.list

    const Confirm = (
      <div className="confirm">
        <h4>Are you sure?</h4>
        <div className="btn-holder">
          <button className="btn" onClick={ this.closeConfirm }><span>No</span></button>
          <button className="btn" onClick={ this.delete.bind(null, this.state.itemId) }><span>Yes</span></button>
        </div>
      </div>
    )

    if (filteredList?.length > 0) {
      const sortedList = this.props.data.table === "articles" || this.props.data.table === "offers" || this.props.data.table === "events" || this.props.data.table === "faq" ? _.orderBy(filteredList, [this.state.sortBy], ['desc']) : filteredList
      list = sortedList.map((item, i) => {
        return (
          <li key={ i }>
            <JSONPretty id="json-pretty" data={item}></JSONPretty>
          </li>
        )
      })
    }


    return (
      <section className="list">
        <div className="container">
    			<h1>{ this.props.data.name }</h1>
          <div className='s-box'>

            <div className='row' style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px'}}>
              <label>User Data:</label>
              <div className="">
                <input type="text" placeholder="User Email" value={ this.state.emailAddress } onChange={ (e) => { this.setState({ emailAddress: e.target.value })} }/>
              </div>
              <p>or</p>
              {/* <label>sf id:</label> */}
              <div className="">
                <input type="text" placeholder="User sf id" value={ this.state.sfId } onChange={ (e) => { this.setState({ sfId: e.target.value })} }/>
              </div>
            </div>


            <label>Touch point:</label>
            <div className="">
            {console.log("😅✌🏼", this.state?.touchpoints)}
            <select
              name="type"
              value={this.state.type}
              onChange={(e) => {
                this.setState({ type: e.target.value });
              }}
            >
              {/* You can optionally have a placeholder option first */}
              <option value="">Select a Touchpoint</option>
              
              {this.state.touchpoints.map((touchpoint) => (
                <option value={touchpoint} key={touchpoint}>
                  {touchpoint}
                </option>
              ))}
            </select>
            </div>
            <div className='s-box'>
              <br />
            <label>Token expires:</label>
            <div className="">
              <DatePicker
                selected={this.state.dateBefore}
                onChange={(dt) => {
                  this.setState({dateBefore: dt})
                  // this.handleSearch()
                }}
                locale="pl"
              />
            </div>
          </div>
            <button onClick={this.handleSearch}>Generate token</button>
          </div>
          <JSONPretty id="json-pretty" data={filteredList}></JSONPretty>
	  	  </div>
        <Modal open={ this.state.confirm } hidePopup={ this.closeConfirm }>{ Confirm }</Modal>
      </section>
    )
  }
}
